var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('register-coworker-form',{attrs:{"form-data":_vm.formData},on:{"register":_vm.register,"cancel":_vm.cancel}})}
var staticRenderFns = []

export { render, staticRenderFns }